<template>
  <div class="common">
    <el-dialog
      class="userTemplate"
      :title="dialogTitle"
      top="5px"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :show-close="true"
      @opened="openedDialog"
      @close="closed"
      center
      append-to-body
    >
      <taskContainer>
        <template v-slot:aside>
          <template-tag
            :height="listHeight"
            :columns="columns"
            ref="templateTag"
            @openSearch="openSearch"
            @getAllTask="getAllTask"
            class="templateTag fl"
            :indexTit="templateTitle"
            :bigTitle="bigTemplateTitle"
            :isBlank="true"
          ></template-tag>
        </template>
        <template v-slot:main>
          <!-- <tabs ref="tabs" :taskClass="taskClass"></tabs> -->
          <taskList ref="taskList" @getValue="getValue" :isGroup="isGroup" :templateQuery="tagItem"></taskList>
        </template>
      </taskContainer>

      <task-search ref="TaskSearch"></task-search>
    </el-dialog>
  </div>
</template>

<script>
import taskContainer from "../Layout/Container.vue";
import taskHeader from "@/views/task/common/header.vue";
import templateTag from "@/components/MainLayout/template/templateTagNew.vue";
import TaskSearch from "@/views/task/components/TaskSearch.vue";
import tabs from "../common/tabs.vue";
import TagButton from "@/views/task/components/ButtonContainer.vue";
import VueButton from "@/views/task/components/Button.vue";
import ApproveButton from "@/views/basicTask/ApproveButton.vue";
import SideList from "@/views/task/components/SideList.vue";
import GroupList from "@/views/task/components/TaskGroup.vue";
import TaskStatView from "@/views/task/statview";
import taskList from "./taskList.vue";
import searchJs from "@/util/search";
import {
  GetTaskListByTaskIdList,
  GetTaskViewHistory
} from "@/api/modules/basicData/task";
import { mapState } from "vuex";
export default {
  components: {
    taskContainer, //整体布局
    taskHeader, //头部
    templateTag, //面板管理界面,
    tabs, //tab切换页面
    TagButton,
    VueButton,
    ApproveButton,
    SideList:()=>import("@/views/task/components/SideList.vue"),
    GroupList,
    taskList,
    TaskStatView,
    TaskSearch //精确查找弹出框页面
  },
  data() {
    return {
      dialogVisible: false,
      templateTitle: "任务模板管理",
      IsTag: true,
      listHeight: "100%",
      bigTemplateTitle: "任务模板",
      curTask: {}, //任务选择值
      taskClass: this.$route.query.taskclass || "",
      type: this.$route.query.type || 2,
      query: this.$route.query.query,
      selectRadioState: "1",
      columns: [
        {
          text: "任务状态",
          value: "TASKSTATENAME"
        },
        {
          text: "任务名称",
          value: "TASKNAME"
        },
        {
          text: "创建人",
          value: "CREATEUSERNAME"
        }
      ],
      viewType: "list"
    };
  },
  props: {
    dialogTitle: {
      type: String,
      default: "任务快速选择"
    },
    dialogWidth: {
      type: String,
      default: "90%"
    },
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      allVisibleTem: state => state.task.allVisibleTem,
      category: state => state.task.category,
      userId: state => state.task.userId,
      tagItem: state => state.task.tagItem
    })
  },
  mounted() {
    
  },
  methods: {
    closed(){
      this.$store.commit('setSelectTaskList',[]);
      this.$store.commit('setIsCheckbox',false);
    },
    getValue(resultList) {
      this.dialogVisible = false;
      this.$emit("getValue", resultList, function(str) {
        //传递值，无论是否验证
        // isValidate = str;
      });
    },
    openedDialog() {
      //打开dialog调用方法
      // this.$refs.templateTag.getLeftAndAll();
      this.$store.commit("setIsCheckbox", true);
      this.$store.commit("setResult", []);
      this.$store.state.task.category=0;
      let a = $(window).height();
      this.listHeight = a - 140 + "px";
      this.$refs.templateTag.getLeftAndAll(); // 获取左侧和所有模板
      if (this.query) {
        this.query = JSON.parse(this.query);
        document.title = this.query.NAME;
        this.getAllTask(this.query);
      } else {
      }
    },
    getAllTask(data) {
      //获取面板数据方法
      // 点击树结构模板动态查询
      console.log("模板值", data);
      this.$store.state.task.tagItem = data;
      if (data.TEMPTYPE == 0) {
        let content = JSON.parse(data.CONTENT);
        console.log(content);
        this.$store.state.task.searchCondition = content.queryTitle;
        if (this.category === 7) {
          this.$store.dispatch(
            "GetTaskGroupTaskList",
            searchJs.searchTaskGroup(content, true)
          );
        } else {
          this.$store.dispatch(
            "changeTaskParas",
            searchJs.searchTask(content, true)
          );
        }
      } else if (data.TEMPTYPE == 1) {
        GetTaskListByTaskIdList(data.CONTENT, this.userId).then(res => {
          // console.log(res, "结果集模板搜索")
          // this.$refs.Suspension.taskSource = res;
          this.$store.state.task.taskSource = res; // taskList任务列表
          if (res.length > 0) {
            this.$store.commit("setResult", res); //  右侧结果集赋值
            this.$store.state.resultBase.isResult = true; //判断当前是否点击结果集
          }
        });
      } else if (data.TEMPTYPE == -1) {
        // 浏览记录
      } else if (data.TEMPTYPE == 6) {
        //自定义菜单
        let componentName = "TaskDelayMain";
        switch (data.ID) {
          case "1020":
            componentName = "TaskDelayMain";
            break;
          case "1030":
            componentName = "TaskRecord";
            break;
          default:
            componentName = "TaskDelayMain";
            break;
        }
      }
    },
    // openSearch(data) {
    //   //查询方法
    //   this.$refs.TaskSearch.SearchOpen(data);
    // },
    openSearch(data) {
      console.log("创建模板----mb0", data);
      if (this.$store.state.task.category == 0) {
        this.$refs.TaskSearch.SearchOpen(data);
      } else if (this.$store.state.task.category == 7) {
      }
    },
    mrmb() {
      // 页面刷新加载默认模板，相当于点击事件
      this.allVisibleTem.forEach(c => {
        if (c.ISDEFAULT) {
          if (c.TEMPTYPE == 0) {
            let content = JSON.parse(c.CONTENT);
            this.$store.state.task.searchCondition = content.queryTitle;
            this.$store.dispatch(
              "changeTaskParas",
              searchJs.searchTask(content, 1)
            );
          } else if (c.TEMPTYPE == 1) {
            this.morenTempS(c.CONTENT);
          }
        }
      });
    },
    morenTempS(val) {
      GetTaskListByTaskIdList(val, this.userId).then(res => {
        console.log(res, "结果集模板搜索");
        this.$store.state.task.taskSource = res;
        if (res.length > 0) {
          this.$store.commit("setResult", res);
          this.$store.state.resultBase.isResult = true;
        }
      });
    },
    changeCurTask(row) {
      console.log("当前选中值", row);
      this.curTask = row;
    },
    onViewTypeChange(type) {
      this.viewType = type;
    },
    stateChange(val) {}
  }
};
</script>

<style lang="scss" scoped>
.common {
  font-family: MicrosoftYaHei;
  color: #165dbd;
  background: #fafbff;
}
</style>
